// src/utils/translations.js
export const translations = {
  fr: {
    title: "Sélections réservées",
    subtitle: "Accédez aux sélections réservées à notre application.",
    discover: "SÉLECTION",
    services: "Nos Services",
    actions: "NOS ACTIONS",
    shop: "SHOP",
    products: "PRODUITS",
    onlineShop: "MAGASIN EN LIGNE",
    eventPlatters: "NOS PLATEAUX ÉVÉNEMENTS",
    login: "LOGIN",
    myAccount: "MON COMPTE",
    myCart: "MON PANIER",
    cartNav: "PANIER",
    search: "Rechercher...",
    historyOpen: "Découvrir l'histoire",
    historyClose: "Fermer l'histoire",
    addCart: "AJOUTER AU PANIER",
    soldOut: "ÉPUISÉ",
    allProducts: "Tous les catégories",
    composeFondue: "COMPOSEZ VOTRE FONDUE",
    eventPlattersShort: "CONFIGUREZ VOTRE PLATEAU ÉVÉNEMENT",

    // Navigation / shell
    menu: "Menu",
    close: "Fermer",
    home: "ACCUEIL",
    mainNavigation: "Navigation principale",

    // Home / sections
    browse: "PARCOURIR",
    categoriesTitle: "Notre sélection",
    categoriesSubtitle:
      "Choisissez une famille de produits et explorez notre sélection.",
    milkTypeFilterKicker: "Affiner",
    milkTypeFilterTitle: "Type de lait",
    allMilkTypes: "Tous les laits",
    milkTypeRaw: "Lait cru",
    milkTypePasteurized: "Pasteurisé",
    milkTypeThermized: "Thermisé",

    // Univers cave / alcool
    alcoolHeroTitle: "NOUS VOUS PROPOSONS EXACTEMENT CE QUE VOUS CHERCHEZ",
    alcoolDiscoverShop: "Découvrir le magasin",
    alcoolSelectionKicker: "Sélection en scène",
    homeAlcoholEntryAria: "Entrée univers cave",
    homeAlcoholEntryKicker: "Univers cave DeLuxe",
    homeAlcoholEntryButton: "Entrer dans la cave",
    alcoolAgeGateTitle: "Avez-vous 18 ans ou plus ?",
    alcoolAgeGateText:
      "L’accès à cet univers est réservé aux personnes majeures. Veuillez confirmer que vous avez au moins 18 ans.",
    alcoolAgeGateAccept: "J’ai 18 ans ou plus",
    alcoolAgeGateDecline: "Je n’ai pas 18 ans",
    alcoolAgeGateKicker: "Accès réglementé",

    // Bannières / marketing
    exclusiveOffers: "PROFITEZ DE NOS OFFRES EXCLUSIVES",
    viewAll: "VOIR TOUTES LES OFFRES",
    memberPriceShort: "MEMBRES",

    // Page Mon Compte
    welcome: "Bienvenue",
    phone: "Téléphone",
    address: "Adresse",
    saveChanges: "Enregistrer les modifications",
    logout: "DÉCONNEXION",
    updating: "Mise à jour...",
    password: "Mot de passe",
    signIn: "Se connecter",
    loginAction: "SE CONNECTER",
    createAccount: "CRÉER UN COMPTE",
    accessExclusive: "Accédez à votre univers Marché Deluxe",
    myOrders: "MES COMMANDES",
    myDetails: "VOS COORDONNÉES",
    editMyInfo: "MODIFIER MES INFOS",
    orderHistory: "HISTORIQUE DES DÉLICES",
    paymentNotConfirmedTitle: "Paiement non confirmé",
    payThisOrder: "PAYER MA COMMANDE",
    orderNumber: "Numéro de commande",
    pricePaid: "Prix payé",
    orderTotal: "Montant de la commande",
    status: "Statut",
    deliveryMode: "Mode de récupération",
    orderDate: "Date de la commande",
    specialInstructions: "Instructions particulières",
    emptyCartData: "Panier indisponible.",
    noOrdersYet: "Aucune commande pour le moment.",
    processing: "Traitement...",
    email: "Email",

    // Logout modal
    logoutModalTitle: "Votre sélection attend son heure",
    logoutModalText:
      "Votre panier est préservé dans votre cave personnelle.\nEn quittant votre session, vous perdrez vos avantages membre et votre sélection sera réinitialisée.",
    logoutModalStay: "Conserver mon panier",
    logoutModalLeave: "Continuer comme visiteur (réinitialiser le panier)",
    logoutModalMoreItems: "+ {count} autres délices...",

    // Suppression de commande
    deleteOrder: "SUPPRIMER LA COMMANDE",
    deletingOrder: "SUPPRESSION...",
    deleteOrderConfirm: "Voulez-vous vraiment supprimer la commande #{id} ?",
    deleteOrderNotAllowed:
      "Cette commande ne peut pas encore être supprimée. Une commande non payée devient supprimable 3 jours après sa création.",
    deleteOrderInfo:
      "Cette commande non payée pourra être supprimée 3 jours après sa création.",

    // Page PANIER / Tunnel
    cartTitle: "VOTRE PANIER",
    emptyCart: "Votre sélection est vide",
    backToShop: "Retourner au magasin",
    discoverCaveUniverse: "Découvrir l’univers cave",
    summary: "RÉSUMÉ",
    subtotal: "Sous-total",
    total: "TOTAL",
    checkout: "COMMANDER",
    finalizeOrder: "FINALISER MA COMMANDE",
    pickupMode: "Mode de récupération",
    deliveryLocal: "LIVRAISON LOCALE",
    shipping: "Expédition",
    pickPay: "Pick & Pay",
    yourInfo: "Vos informations",
    firstName: "Prénom",
    lastName: "Nom",
    npa: "NPA",
    city: "Ville",
    payment: "Paiement",
    creditCard: "Carte de crédit",
    invoice: "Facture",
    totalToPay: "TOTAL À PAYER",
    items: "Articles",
    fees: "Frais",
    pay: "PAYER",
    validating: "VALIDATION EN COURS...",
    backToCart: "Retour au panier",
    thankYouOrder: "Merci pour votre commande",
    orderRegistered: "Votre commande a bien été enregistrée.",
    redirectingPayment: "REDIRECTION VERS LE PAIEMENT...",
    panierAlcoholNotice:
      "En validant cette commande, vous certifiez avoir au moins 18 ans pour l’achat de boissons alcoolisées.",
    cartRecommendationsInlineTitle: "À savourer avec",
    addToCart: "Ajouter",
    panierWeightNotice:
      "Les produits coupés au poids sont préparés avec soin en magasin. Le poids final peut être légèrement supérieur à la quantité commandée. Le prix facturé reste celui de la quantité commandée.",

    // Bloc paiement sécurisé
    securePaymentTitle: "Paiement sécurisé",
    availablePaymentMethods: "Moyens de paiement disponibles",
    securePaymentFinalChoice:
      "Le choix final du moyen de paiement s’effectue sur la page de paiement sécurisée.",
    bankCardLabel: "Carte bancaire",
    twintLabel: "TWINT",

    // Livraison / instructions (hors categories)
    freeDeliveryTarget: "Plus que {{amount}} CHF pour la livraison gratuite !",
    deliveryFees: "Livraison",
    deliveryInstructions: "Instructions de livraison :",
    deliveryPlaceholder: "précisions...",
    prepNotes: "Précisions préparation (ex: sous-vide) :",
    prepPlaceholder: "Instructions spéciales (emballage, etc.)...",
    pickupTime: "HORAIRE DE RETRAIT :",
    chooseSlot: "Choisir un créneau",
    free: "OFFERTE",

    // Page Services
    servicesSubtitle:
      "Une expérience simple, rapide et premium — du panier à la dégustation.",
    ctaShop: "Accéder au magasin",
    ctaCart: "Voir Mon panier",
    howItWorks: "Comment ça marche",
    step1Title: "1. Choisissez vos produits",
    step1Text: "Parcourez la sélection et ajoutez au panier.",
    step2Title: "2. Livraison ou retrait",
    step2Text: "Sélectionnez le mode de récupération qui vous convient.",
    step3Title: "3. Finalisez facilement",
    step3Text: "Confirmez votre commande en quelques secondes.",
    serviceReadyTitle: "Votre sélection prête à partir",
    serviceReadyText: "Commandez, récupérez et savourez.",
    pick1: "Préparation soignée et rapide",
    pick2: "Retrait simple et efficace",
    pick3: "Qualité premium, sans attente",
    ctaOrder: "Commander maintenant",
    ctaFinalize: "Finaliser ma commande",

    deliveryTitle: "Livraison Locale (bientôt disponible)",
    deliveryZone: "Livraison sur Neuchâtel et environs.",
    deliveryFree: "Gratuit dès 59.00 CHF",
    deliveryBeforeLabel: "Avant 12h00",
    deliveryBefore: "Livraison le jour même",
    deliveryAfterLabel: "Après 12h00",
    deliveryAfter: "Livraison le lendemain",

    faq: "FAQ",
    faqQ1: "Puis-je commander sans compte ?",
    faqA1:
      "Oui, vous pouvez commander en visiteur (prénom, nom, téléphone requis).",
    faqQ2: "Puis-je choisir un créneau ?",
    faqA2: "Oui, en mode Pick & Pay vous choisissez votre horaire de retrait.",

    // Plateaux événements
    plateauxPageTitle: "NOS PLATEAUX ÉVÉNEMENTS",
    plateauxPageKicker: "Plateaux événements",
    plateauxPageIntro:
      "Découvrez nos plateaux artisanaux pensés pour vos événements, apéritifs et repas conviviaux. Commencez par choisir le type de plateau qui correspond à votre occasion. Vous pourrez ensuite le personnaliser (nombre de personnes, préférence et restrictions) avant de l’ajouter au panier.",
    plateauxHeroAlt: "Illustration plateaux événements",
    plateauxSelectionTitle: "Choisir un type de plateau",
    plateauxSelectionKicker: "Étape 1",
    plateauxConfigTitle: "Configurer votre plateau",
    plateauxConfigKicker: "Étape 2",
    plateauxSelectionHint:
      "Choisissez d’abord une base. La personnalisation du plateau s’affichera ensuite juste en dessous.",
    plateauxChangeSelection: "Voir les autres plateaux",
    plateauxSelectedLabel: "Plateau sélectionné",
    plateauxEmptyState:
      "Sélectionnez un plateau pour afficher la configuration détaillée.",
    plateauxNoItemsAvailable: "Aucun plateau n’est disponible pour le moment.",

    plateauConfiguratorKicker: "Configuration du plateau",
    plateauEditorialHighlight:
      "Plateau artisanal préparé par nos fromagers. Idéal pour vos événements, apéritifs et repas conviviaux.",
    plateauConsignesTitle: "Consignes de plateaux",
    plateauConsigneSmall: "Petit",
    plateauConsigneMedium: "Moyen",
    plateauConsigneLarge: "Grand",
    plateauPeopleLabel: "Nombre de personnes",
    plateauPeopleHelper:
      "Le prix est calculé automatiquement selon le nombre de convives.",
    plateauDecreasePeople: "Réduire le nombre de personnes",
    plateauIncreasePeople: "Augmenter le nombre de personnes",
    plateauCheesePreferencesLabel: "Préférences de fromages",
    plateauOptional: "(optionnel)",
    plateauCheesePreferencesPlaceholder: "Ex : Comté, Gruyère, Tomme, Bleu...",
    plateauAvoidMilkTypesLabel: "Éviter certains types de lait",
    plateauRawMilk: "Lait cru",
    plateauThermizedMilk: "Lait thermisé",
    plateauPasteurizedMilk: "Lait pasteurisé",
    plateauMilkNote:
      "Les plateaux contiennent plusieurs fromages. Vous pouvez indiquer ici les types de lait que vous souhaitez éviter.",
    plateauPricePerPerson: "Prix par personne",
    plateauPeopleCount: "Nombre de personnes",
    plateauPreferences: "Préférences",
    plateauAvoid: "À éviter",
    plateauNoPreference: "Aucune préférence",
    plateauNoRestriction: "Aucune restriction",
    plateauTotal: "Total",
    plateauAddToCart: "Ajouter au panier",
    plateauDelayInfo:
      "Les plateaux doivent être commandés au minimum 24h à l'avance.",
    plateauPriceSuffix: "/ personne",
    plateauSelected: "✓ Sélectionné",
    plateauChoose: "Choisir",
    plateauAddedToCart: "Plateau ajouté au panier",
    plateauPostAddShop: "Découvrir la boutique",
    plateauPostAddCave: "Visiter notre cave",
    plateauPostAddTop: "Remonter en haut",

    // Catégories
    categories: {
      fromage_vache: "Fromage de Vache",
      fromage_brebis: "Fromage de Brebis",
      fromage_chevre: "Fromage de Chèvre",
      charcuterie: "Charcuterie",
      produit_laitier: "Produits Laitiers",
      panier_garni: "Paniers Garnis",
      vin: "Vins",
      divers: "Divers",
      oeuf: "Œufs",
    },

    // Auth / reset password
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordTitle: "Mot de passe oublié",
    forgotPasswordSubtitle: "Recevez un lien de réinitialisation par email.",
    sendResetLink: "ENVOYER LE LIEN DE RÉINITIALISATION",
    resetPasswordTitle: "Nouveau mot de passe",
    resetPasswordSubtitle:
      "Choisissez un nouveau mot de passe pour votre compte.",
    resetPasswordAction: "RÉINITIALISER LE MOT DE PASSE",
    confirmPassword: "Confirmer le mot de passe",
    backToLogin: "Retour à la connexion",
    resetMailSent:
      "Si un compte existe avec cet email, un lien de réinitialisation a été envoyé.",
    resetSuccess: "Votre mot de passe a été réinitialisé avec succès.",
    resetError: "Impossible de réinitialiser le mot de passe.",

    // Footer / pages légales
    legalNotices: "Mentions légales",
    privacyPolicy: "Politique de confidentialité",
    twintTermsNav: "Conditions TWINT",

    // Mentions légales
    legalPageTitle: "Mentions légales",
    legalPageSubtitle:
      "Informations légales relatives à l’éditeur du site et à l’exploitation de la boutique en ligne.",
    legalSectionCompany: "Identification de l’entreprise",
    legalSectionContact: "Coordonnées",
    legalSectionHosting: "Hébergement et infrastructure",
    legalSectionUsage: "Conditions d’utilisation",
    legalCompanyNameLabel: "Nom de l’entreprise",
    legalCompanyNameValue: "La Maison du Fromage Neuchâtel - Sterchi Sàrl",
    legalAddressLabel: "Adresse",
    legalAddressValue: "rue du Trésor 2 bis, 2000 Neuchâtel, Suisse",
    legalLegalFormLabel: "Forme juridique",
    legalLegalFormValue: "Société à responsabilité limitée (Sàrl)",
    legalVatLabel: "Numéro TVA",
    legalVatValue: "CHE-192.944.984 TVA",
    legalPhoneLabel: "Téléphone",
    legalPhoneValue: "+41 32 725 26 36",
    legalEmailLabel: "Email",
    legalEmailValue: "neuch@sterchi-fromages.ch",
    legalHostingText:
      "Le site et l’application Marché Deluxe sont exploités sur une infrastructure web sécurisée. L’application e-commerce est accessible via app.marchedeluxe.ch.",
    legalUsageTitle: "Conditions d’utilisation",
    legalUsageItems: [
      "L’utilisation du site Marché Deluxe implique l’acceptation d’un usage conforme à sa destination, à savoir la consultation des produits, la préparation d’achats, la passation de commandes et l’accès à l’espace client.",
      "L’utilisateur s’engage à fournir des informations exactes lors de la création d’un compte, de la passation de commande et lors de toute communication avec la boutique.",
      "Toute utilisation frauduleuse, abusive ou portant atteinte au bon fonctionnement du site pourra entraîner une restriction d’accès ou toute mesure appropriée décidée par l’exploitant.",
      "Les contenus présents sur le site (textes, visuels, éléments graphiques, photographies et informations) sont protégés et ne peuvent être reproduits, copiés ou exploités sans autorisation préalable.",
      "La disponibilité du site ne peut être garantie en permanence. L’exploitant se réserve le droit de suspendre ou modifier tout ou partie du service pour maintenance, mise à jour ou raisons techniques.",
    ],

    // Politique de confidentialité
    privacyPageTitle: "Politique de confidentialité",
    privacyPageSubtitle:
      "Informations sur la collecte, l’utilisation et la protection des données personnelles dans le cadre de Marché Deluxe.",
    privacyIntro:
      "La présente politique de confidentialité explique quelles données peuvent être collectées lorsque vous utilisez le site et l’application Marché Deluxe, ainsi que la manière dont elles sont utilisées pour le traitement des commandes, la relation client et la sécurité du service.",
    privacySectionCollected: "Données collectées",
    privacyCollectedItems: [
      "Informations de compte : prénom, nom, email, téléphone, adresse, NPA, ville.",
      "Informations de commande : contenu du panier, mode de récupération, notes de commande, statut de paiement.",
      "Informations techniques nécessaires au fonctionnement du service et à la sécurité de l’application.",
    ],
    privacySectionUsage: "Utilisation des données",
    privacyUsageItems: [
      "Préparer, traiter et livrer les commandes.",
      "Gérer la relation client et répondre aux demandes.",
      "Assurer le suivi des paiements et prévenir les fraudes.",
      "Maintenir la sécurité, la stabilité et la continuité du service.",
    ],
    privacySectionSharing: "Partage des données",
    privacySharingText:
      "Certaines données peuvent être transmises aux prestataires strictement nécessaires au fonctionnement du service, notamment pour le paiement, l’hébergement et l’exécution des commandes. Ces transmissions sont limitées à ce qui est nécessaire.",
    privacySectionRetention: "Conservation",
    privacyRetentionText:
      "Les données sont conservées pendant la durée nécessaire au traitement des commandes, au respect des obligations légales et à la gestion de la relation commerciale.",
    privacySectionRights: "Vos droits",
    privacyRightsText:
      "Vous pouvez demander l’accès, la rectification ou la suppression de vos données, dans les limites prévues par le droit applicable, en contactant l’entreprise aux coordonnées indiquées dans les mentions légales.",

    // TWINT
    twintTermsTitle: "Conditions de paiement TWINT",
    twintTermsUpdated: "Dernière mise à jour : 31 octobre 2024",
    twintTermsIntro:
      "TWINT est l’une des principales applications de paiement instantané utilisées en Suisse. TWINT permet aux utilisateurs de connecter leur compte bancaire ou leurs cartes à l’application TWINT afin d’effectuer des paiements sécurisés. Votre acceptation et votre utilisation de TWINT via les services de paiement Stripe sont soumises aux présentes conditions du moyen de paiement, qui complètent le contrat de services Stripe concernant votre acceptation et votre utilisation de TWINT :",
    twintTermsItems: [
      "Lorsque vous acceptez le moyen de paiement TWINT pour des services qui ne peuvent pas être fournis immédiatement, vous vous engagez à informer vos clients par écrit de la fourniture différée du service.",
      "Vous vous engagez à obtenir le numéro de téléphone mobile du client utilisant TWINT et à vérifier ces informations.",
      "Vous vous engagez à partager le numéro de téléphone mobile du client avec Stripe lorsque cela vous est demandé.",
      "Lors du traitement de transactions à distance impliquant un achat avec livraison physique de marchandises, vous vous engagez à obtenir le nom, le prénom, le numéro de téléphone mobile et l’adresse de résidence du client utilisant TWINT, et à vérifier ces informations, en particulier lorsque l’adresse de résidence et l’adresse de livraison sont différentes. Vous êtes tenu d’indiquer le nom de l’entreprise utilisé dans votre boutique en ligne ou votre application dans toutes les informations fournies au client utilisant TWINT (par exemple : confirmations de commande ou de livraison, factures).",
    ],

    fondueBack: "Retour",
    fondueBrand: "STERCHI",
    fondueHeroTitle: "COMPOSEZ VOTRE FONDUE",
    fondueHeroText:
      "Découvrez nos recettes traditionnelles suisses ou créez votre propre mélange selon vos goûts.",

    fondueTraditionalTitle: "FONDUES TRADITIONNELLES",
    fondueTraditionalSubtitle: "Découvrez nos recettes cantonales",

    fondueCustomSubtitle: "Choisissez vos fromages et composez votre mélange",

    fondueQualityTitle: "Qualité premium",
    fondueQualityText: "Fromages AOP",
    fondueCraftTitle: "Fait avec passion",
    fondueCraftText: "Maison Sterchi",
    fonduePickupTitle: "Sur place",
    fonduePickupText: "Prête à votre arrivée",

    fondueRegionZurich: "Zurich",
    fondueZurichName: "Zurichoise",
    fondueZurichDesc:
      "Une fondue urbaine et équilibrée avec une belle complexité.",
    fondueCustomTitle: "Ma composition",
    fondueCustomIntroTitle: "Composez votre caquelon",
    fondueCustomIntroText:
      "Sélectionnez jusqu’à 3 fromages, puis choisissez le ratio de votre mélange. Le total doit faire 100%.",

    fonduePeopleCount: "Nombre de personnes",
    fondueRecommendedQuantity: "Quantité recommandée",
    fondueCategories: "Catégories",
    fondueSearchPlaceholder: "Rechercher un fromage...",
    fondueChooseCategoryHint:
      "Sélectionnez une catégorie pour voir les fromages disponibles.",

    fondueCategoryGoatSheep: "Chèvre & Brebis",
    fondueCategoryBlue: "Bleus",
    fondueCategoryHard: "Durs & mi-durs",
    fondueCategorySoft: "Pâtes molles",

    fondueAvailableCheeses: "Fromages disponibles",
    fondueNoCheeseInCategory: "Aucun fromage disponible dans cette catégorie.",
    fondueAddToCaquelon: "Ajouter au caquelon",
    fondueInCaquelon: "Au caquelon",

    fondueMyMix: "Mon mélange",
    fondueMixEmpty:
      "Ajoutez un fromage au caquelon pour commencer votre mélange.",
    fondueValidateCaquelon: "Valider mon caquelon",

    fondueRatioTitle: "Concoctez votre fondue idéale",
    fondueRatioSubtitle: "Sélectionnez vos ratios",
    fondueSelectedCheeseSingular: "fromage sélectionné",
    fondueSelectedCheesePlural: "fromages sélectionnés",
    fondueRatioTip:
      "Conseil : plus la part d’un fromage est élevée, plus son goût sera présent dans votre fondue.",
    fondueRatioTotal: "Total ratios",

    fondueAddToCart: "Ajouter au panier",
    fondueValidateCaquelonFirst: "Zugriff auf die exklusiven Auswahlmöglichkeiten unserer App.",
    fondueCustomAddedToCart: "Fondue personnalisée",
    fondueRatioRequired: "Ratio à 100% requis",
    fondueRatioMustBe100: "Le total des ratios doit être égal à 100%",
    fondueAddOneCheese: "Ajoutez au moins un fromage au caquelon",
    fondueMaxThreeCheeses: "Maximum 3 fromages par caquelon",
    heroTrustSubtitle: "Des sélections rares, choisies avec passion par Cerdric Naudin.",
    heroTrustCheese: "FROMAGES D’EXCEPTION",
    heroTrustCave: "SÉLECTIONS CAVE",
    heroTrustPlateaux: "PLATEAUX PERSONNALISÉS",
    heroTrustOffers: "OFFRES PRIVÉES",
  },

  de: {
    title: "Reservierte Auswahl",
    subtitle: "Regionale Auswahl von Cédric Naudin.",
    discover: "SELEKTION",
    services: "Unsere Dienste",
    actions: "AKTIONEN",
    shop: "SHOP",
    products: "PRODUKTE",
    onlineShop: "ONLINE-SHOP",
    eventPlatters: "UNSERE EVENT-PLATTEN",
    login: "ANMELDEN",
    myAccount: "MEIN KONTO",
    myCart: "MEIN WARENKORB",
    cartNav: "WARENKORB",
    search: "Suche...",
    historyOpen: "Geschichte entdecken",
    historyClose: "Geschichte schliessen",
    addCart: "IN DEN WARENKORB",
    soldOut: "AUSVERKAUFT",
    allProducts: "Alle Kategorien",
    composeFondue: "FONDUE ZUSAMMENSTELLEN",
    eventPlattersShort: "EVENT-PLATTE KONFIGURIEREN",

    menu: "Menü",
    close: "Schliessen",
    home: "START",
    mainNavigation: "Hauptnavigation",

    browse: "ENTDECKEN",
    categoriesTitle: "Unsere Auswahl",
    categoriesSubtitle:
      "Wählen Sie eine Produktfamilie und entdecken Sie unsere Auswahl.",
    milkTypeFilterKicker: "Verfeinern",
    milkTypeFilterTitle: "Milchart",
    allMilkTypes: "Alle Milcharten",
    milkTypeRaw: "Rohmilch",
    milkTypePasteurized: "Pasteurisiert",
    milkTypeThermized: "Thermisiert",

    // Univers cave / alcool
    alcoolHeroTitle: "WIR BIETEN IHNEN GENAU DAS, WAS SIE SUCHEN",
    alcoolDiscoverShop: "Den Shop entdecken",
    alcoolSelectionKicker: "Auswahl in Szene",
    homeAlcoholEntryAria: "Einstieg in die Weinwelt",
    homeAlcoholEntryKicker: "DeLuxe Weinwelt",
    homeAlcoholEntryButton: "In den Weinkeller eintreten",

    exclusiveOffers: "UNSERE EXKLUSIVEN ANGEBOTE",
    viewAll: "Alle ansehen",
    memberPriceShort: "MITGLIEDER",
    alcoolAgeGateTitle: "Sind Sie 18 Jahre oder älter?",
    alcoolAgeGateText:
      "Der Zugang zu diesem Bereich ist nur für Erwachsene bestimmt. Bitte bestätigen Sie, dass Sie mindestens 18 Jahre alt sind.",
    alcoolAgeGateAccept: "Ich bin 18 oder älter",
    alcoolAgeGateDecline: "Ich bin unter 18",
    alcoolAgeGateKicker: "Eingeschränkter Zugang",

    welcome: "Willkommen",
    phone: "Telefon",
    address: "Adresse",
    saveChanges: "Änderungen speichern",
    logout: "ABMELDEN",
    updating: "Aktualisierung...",
    password: "Passwort",
    signIn: "Einloggen",
    loginAction: "EINLOGGEN",
    createAccount: "NEU ANMELDEN",
    accessExclusive: "Zugriff auf Ihr Universum Marché Deluxe",
    myOrders: "MEINE BESTELLUNGEN",
    myDetails: "IHRE DATEN",
    editMyInfo: "MEINE DATEN BEARBEITEN",
    orderHistory: "BESTELLVERLAUF",
    paymentNotConfirmedTitle: "Zahlung nicht bestätigt",
    payThisOrder: "MEINE BESTELLUNG BEZAHLEN",
    orderNumber: "Bestellnummer",
    pricePaid: "Bezahlter Preis",
    orderTotal: "Bestellbetrag",
    status: "Status",
    deliveryMode: "Abholart",
    orderDate: "Bestelldatum",
    specialInstructions: "Besondere Hinweise",
    emptyCartData: "Warenkorb nicht verfügbar.",
    noOrdersYet: "Noch keine Bestellungen.",
    processing: "Verarbeitung...",
    email: "E-Mail",

    // Logout modal
    logoutModalTitle: "Ihre Auswahl wartet auf Sie",
    logoutModalText:
      "Ihr Warenkorb wird in Ihrem persönlichen Bereich gespeichert.\nWenn Sie sich abmelden, verlieren Sie Ihre Mitgliedsvorteile und Ihre Auswahl wird zurückgesetzt.",
    logoutModalStay: "Warenkorb behalten",
    logoutModalLeave: "Als Besucher fortfahren (Warenkorb zurücksetzen)",
    logoutModalMoreItems: "+ {count} weitere Köstlichkeiten...",

    // Suppression de commande
    deleteOrder: "BESTELLUNG LÖSCHEN",
    deletingOrder: "LÖSCHUNG...",
    deleteOrderConfirm: "Möchten Sie die Bestellung #{id} wirklich löschen?",
    deleteOrderNotAllowed:
      "Diese Bestellung kann noch nicht gelöscht werden. Eine unbezahlte Bestellung kann erst 3 Tage nach Erstellung gelöscht werden.",
    deleteOrderInfo:
      "Diese unbezahlte Bestellung kann 3 Tage nach ihrer Erstellung gelöscht werden.",

    cartTitle: "IHR WARENKORB",
    emptyCart: "Ihr Warenkorb ist leer",
    backToShop: "Zurück zum Shop",
    discoverCaveUniverse: "ENTDECKEN DES GROTTEN UNIVERSUMS",
    summary: "ZUSAMMENFASSUNG",
    subtotal: "Zwischensumme",
    total: "TOTAL",
    checkout: "BESTELLEN",
    finalizeOrder: "BESTELLUNG ABSCHLIESSEN",
    pickupMode: "Abholmodus",
    deliveryLocal: "LOKALE LIEFERUNG",
    shipping: "Versand",
    pickPay: "Pick & Pay",
    yourInfo: "Ihre Informationen",
    firstName: "Vorname",
    lastName: "Nachname",
    npa: "PLZ",
    city: "Stadt",
    payment: "Zahlung",
    creditCard: "Kreditkarte",
    invoice: "Rechnung",
    totalToPay: "ZU ZAHLENDER GESAMTBETRAG",
    items: "Artikel",
    fees: "Gebühren",
    pay: "BEZAHLEN",
    validating: "VALIDIERUNG LÄUFT...",
    backToCart: "Zurück zum Warenkorb",
    thankYouOrder: "Vielen Dank für Ihre Bestellung",
    orderRegistered: "Ihre Bestellung wurde erfolgreich registriert.",
    redirectingPayment: "WEITERLEITUNG ZUR ZAHLUNG...",
    cartRecommendationsInlineTitle: "Passt perfekt dazu",
    addToCart: "Hinzufügen",

    securePaymentTitle: "Sichere Zahlung",
    availablePaymentMethods: "Verfügbare Zahlungsmethoden",
    securePaymentFinalChoice:
      "Die endgültige Auswahl der Zahlungsmethode erfolgt auf der sicheren Zahlungsseite.",
    bankCardLabel: "Kreditkarte",
    twintLabel: "TWINT",

    freeDeliveryTarget: "Noch {{amount}} CHF bis zur kostenlosen Lieferung!",
    deliveryFees: "Lieferung",
    deliveryInstructions: "Lieferanweisungen:",
    deliveryPlaceholder: "Details...",
    prepNotes: "Hinweise zur Vorbereitung (z. B. vakuumverpackt):",
    prepPlaceholder: "Spezielle Anweisungen (Verpackung usw.)...",
    pickupTime: "ABHOLZEIT:",
    chooseSlot: "Zeitfenster wählen",
    free: "GRATIS",

    servicesSubtitle:
      "Ein einfaches, schnelles und hochwertiges Erlebnis — vom Warenkorb bis zur Degustation.",
    ctaShop: "Zum Shop",
    ctaCart: "Meinen Warenkorb ansehen",
    howItWorks: "So funktioniert es",
    step1Title: "1. Wählen Sie Ihre Produkte",
    step1Text:
      "Durchstöbern Sie die Auswahl und legen Sie Produkte in den Warenkorb.",
    step2Title: "2. Lieferung oder Abholung",
    step2Text:
      "Wählen Sie die für Sie passende Art der Abholung oder Lieferung.",
    step3Title: "3. Schnell abschliessen",
    step3Text: "Bestätigen Sie Ihre Bestellung in wenigen Sekunden.",
    serviceReadyTitle: "Ihre Auswahl ist bereit",
    serviceReadyText: "Bestellen, abholen und geniessen.",
    pick1: "Sorgfältige und schnelle Vorbereitung",
    pick2: "Einfache und effiziente Abholung",
    pick3: "Premium-Qualität ohne Wartezeit",
    ctaOrder: "Jetzt bestellen",
    ctaFinalize: "Meine Bestellung abschliessen",

    deliveryTitle: "Lokale Lieferung",
    deliveryZone: "Lieferung in Neuchâtel und Umgebung.",
    deliveryFree: "Kostenlos ab 59.00 CHF",
    deliveryBeforeLabel: "Vor 12:00 Uhr",
    deliveryBefore: "Lieferung am selben Tag",
    deliveryAfterLabel: "Nach 12:00 Uhr",
    deliveryAfter: "Lieferung am nächsten Tag",

    faq: "FAQ",
    faqQ1: "Kann ich ohne Konto bestellen?",
    faqA1:
      "Ja, Sie können als Gast bestellen (Vorname, Nachname und Telefonnummer erforderlich).",
    faqQ2: "Kann ich ein Zeitfenster wählen?",
    faqA2: "Ja, im Pick & Pay-Modus wählen Sie Ihre Abholzeit selbst.",
    panierAlcoholNotice:
      "Mit dem Absenden dieser Bestellung bestätigen Sie, dass Sie mindestens 18 Jahre alt sind, um alkoholische Getränke zu kaufen.",
    panierWeightNotice:
      "Produkte, die nach Gewicht zugeschnitten werden, werden im Geschäft mit Sorgfalt vorbereitet. Das endgültige Gewicht kann leicht über der bestellten Menge liegen. Der berechnete Preis bleibt derjenige der bestellten Menge.",

    // Event-Platten
    plateauxPageTitle: "UNSERE EVENT-PLATTEN",
    plateauxPageKicker: "Event-Platten",
    plateauxPageIntro:
      "Entdecken Sie unsere handwerklich zusammengestellten Platten für Ihre Anlässe, Aperitifs und geselligen Mahlzeiten. Wählen Sie zuerst die passende Plattenart. Anschliessend können Sie diese personalisieren (Personenzahl, Vorlieben und Einschränkungen), bevor Sie sie in den Warenkorb legen.",
    plateauxHeroAlt: "Illustration Event-Platten",
    plateauxSelectionTitle: "Eine Plattenart wählen",
    plateauxSelectionKicker: "Schritt 1",
    plateauxConfigTitle: "Ihre Platte konfigurieren",
    plateauxConfigKicker: "Schritt 2",
    plateauxSelectionHint:
      "Wählen Sie zuerst eine Basis. Die Personalisierung wird anschliessend direkt darunter angezeigt.",
    plateauxChangeSelection: "Andere Platten ansehen",
    plateauxSelectedLabel: "Ausgewählte Platte",
    plateauxEmptyState:
      "Wählen Sie eine Platte aus, um die detaillierte Konfiguration anzuzeigen.",
    plateauxNoItemsAvailable: "Zurzeit sind keine Platten verfügbar.",

    plateauConfiguratorKicker: "Plattenkonfiguration",
    plateauEditorialHighlight:
      "Handwerklich von unseren Käsern vorbereitete Platte. Ideal für Ihre Anlässe, Aperitifs und geselligen Mahlzeiten.",
    plateauConsignesTitle: "Plattenzuschläge",
    plateauConsigneSmall: "Klein",
    plateauConsigneMedium: "Mittel",
    plateauConsigneLarge: "Gross",
    plateauPeopleLabel: "Anzahl Personen",
    plateauPeopleHelper:
      "Der Preis wird automatisch nach Anzahl der Gäste berechnet.",
    plateauDecreasePeople: "Personenzahl verringern",
    plateauIncreasePeople: "Personenzahl erhöhen",
    plateauCheesePreferencesLabel: "Käsevorlieben",
    plateauOptional: "(optional)",
    plateauCheesePreferencesPlaceholder:
      "Z. B.: Comté, Gruyère, Tomme, Blauschimmel...",
    plateauAvoidMilkTypesLabel: "Bestimmte Milcharten vermeiden",
    plateauRawMilk: "Rohmilch",
    plateauThermizedMilk: "Thermisierte Milch",
    plateauPasteurizedMilk: "Pasteurisierte Milch",
    plateauMilkNote:
      "Die Platten enthalten mehrere Käsesorten. Hier können Sie angeben, welche Milcharten Sie vermeiden möchten.",
    plateauPricePerPerson: "Preis pro Person",
    plateauPeopleCount: "Anzahl Personen",
    plateauPreferences: "Vorlieben",
    plateauAvoid: "Zu vermeiden",
    plateauNoPreference: "Keine Vorlieben",
    plateauNoRestriction: "Keine Einschränkung",
    plateauTotal: "Total",
    plateauAddToCart: "In den Warenkorb",
    plateauDelayInfo:
      "Die Platten müssen mindestens 24 Stunden im Voraus bestellt werden.",
    plateauPriceSuffix: "/ Person",
    plateauSelected: "✓ Ausgewählt",
    plateauChoose: "Wählen",
    plateauAddedToCart: "Platte zum Warenkorb hinzugefügt",
    plateauPostAddShop: "Zur Boutique",
    plateauPostAddCave: "Unseren Weinkeller entdecken",
    plateauPostAddTop: "Nach oben",

    categories: {
      fromage_vache: "Kuhkäse",
      fromage_brebis: "Schafskäse",
      fromage_chevre: "Ziegenkäse",
      charcuterie: "Aufschnitt",
      produit_laitier: "Molkereiprodukte",
      panier_garni: "Geschenkkörbe",
      vin: "Weine",
      divers: "Verschiedenes",
      oeuf: "Eier",
    },

    forgotPassword: "Passwort vergessen?",
    forgotPasswordTitle: "Passwort vergessen",
    forgotPasswordSubtitle:
      "Sie erhalten einen Link zum Zurücksetzen Ihres Passworts per E-Mail.",
    sendResetLink: "LINK ZUM ZURÜCKSETZEN SENDEN",
    resetPasswordTitle: "Neues Passwort",
    resetPasswordSubtitle: "Wählen Sie ein neues Passwort für Ihr Konto.",
    resetPasswordAction: "PASSWORT ZURÜCKSETZEN",
    confirmPassword: "Passwort bestätigen",
    backToLogin: "Zurück zur Anmeldung",
    resetMailSent:
      "Falls ein Konto mit dieser E-Mail existiert, wurde ein Reset-Link gesendet.",
    resetSuccess: "Ihr Passwort wurde erfolgreich zurückgesetzt.",
    resetError: "Passwort konnte nicht zurückgesetzt werden.",

    legalNotices: "Impressum",
    privacyPolicy: "Datenschutz",
    twintTermsNav: "TWINT-Bedingungen",

    legalPageTitle: "Impressum",
    legalPageSubtitle:
      "Rechtliche Informationen zum Betreiber der Website und zum Online-Shop.",
    legalSectionCompany: "Unternehmensangaben",
    legalSectionContact: "Kontakt",
    legalSectionHosting: "Hosting und Infrastruktur",
    legalSectionUsage: "Nutzungsbedingungen",
    legalCompanyNameLabel: "Unternehmensname",
    legalCompanyNameValue: "La Maison du Fromage Neuchâtel - Sterchi Sàrl",
    legalAddressLabel: "Adresse",
    legalAddressValue: "rue du Trésor 2 bis, 2000 Neuchâtel, Schweiz",
    legalLegalFormLabel: "Rechtsform",
    legalLegalFormValue: "Gesellschaft mit beschränkter Haftung (Sàrl)",
    legalVatLabel: "MwSt.-Nummer",
    legalVatValue: "CHE-192.944.984 TVA",
    legalPhoneLabel: "Telefon",
    legalPhoneValue: "+41 32 725 26 36",
    legalEmailLabel: "E-Mail",
    legalEmailValue: "neuch@sterchi-fromages.ch",
    legalHostingText:
      "Die Website und die Marché-Deluxe-Anwendung werden auf einer gesicherten Web-Infrastruktur betrieben. Die E-Commerce-Anwendung ist über app.marchedeluxe.ch zugänglich.",
    legalUsageTitle: "Nutzungsbedingungen",
    legalUsageItems: [
      "Die Nutzung der Website Marché Deluxe setzt die Zustimmung zu einer ihrer Bestimmung entsprechenden Nutzung voraus, nämlich zur Einsicht in die Produkte, zur Vorbereitung von Einkäufen, zur Aufgabe von Bestellungen und zum Zugang zum Kundenbereich.",
      "Der Nutzer verpflichtet sich, bei der Erstellung eines Kontos, bei der Bestellung und bei jeder Kommunikation mit dem Geschäft korrekte Angaben zu machen.",
      "Jede betrügerische, missbräuchliche oder den ordnungsgemäßen Betrieb der Website beeinträchtigende Nutzung kann zu einer Zugangsbeschränkung oder zu jeder anderen vom Betreiber als angemessen erachteten Maßnahme führen.",
      "Die auf der Website enthaltenen Inhalte (Texte, Bilder, grafische Elemente, Fotografien und Informationen) sind geschützt und dürfen ohne vorherige Genehmigung nicht reproduziert, kopiert oder genutzt werden.",
      "Die ständige Verfügbarkeit der Website kann nicht garantiert werden. Der Betreiber behält sich das Recht vor, den Dienst ganz oder teilweise für Wartungsarbeiten, Aktualisierungen oder aus technischen Gründen auszusetzen oder zu ändern.",
    ],

    privacyPageTitle: "Datenschutzerklärung",
    privacyPageSubtitle:
      "Informationen zur Erhebung, Nutzung und zum Schutz personenbezogener Daten im Rahmen von Marché Deluxe.",
    privacyIntro:
      "Diese Datenschutzerklärung erläutert, welche Daten bei der Nutzung der Website und der Marché-Deluxe-Anwendung erhoben werden können und wie diese für die Bestellabwicklung, die Kundenbeziehung und die Sicherheit des Dienstes verwendet werden.",
    privacySectionCollected: "Erhobene Daten",
    privacyCollectedItems: [
      "Kontodaten: Vorname, Nachname, E-Mail, Telefon, Adresse, PLZ, Ort.",
      "Bestelldaten: Warenkorbinhalt, Abhol- oder Liefermodus, Bestellnotizen, Zahlungsstatus.",
      "Technische Informationen, die für den Betrieb des Dienstes und die Sicherheit der Anwendung erforderlich sind.",
    ],
    privacySectionUsage: "Verwendung der Daten",
    privacyUsageItems: [
      "Bestellungen vorbereiten, bearbeiten und liefern.",
      "Kundenbeziehung verwalten und Anfragen beantworten.",
      "Zahlungen nachverfolgen und Betrug vorbeugen.",
      "Sicherheit, Stabilität und Kontinuität des Dienstes gewährleisten.",
    ],
    privacySectionSharing: "Weitergabe von Daten",
    privacySharingText:
      "Bestimmte Daten können an Dienstleister weitergegeben werden, die für den Betrieb des Dienstes erforderlich sind, insbesondere für Zahlung, Hosting und Auftragsabwicklung. Diese Übermittlungen sind auf das Notwendige beschränkt.",
    privacySectionRetention: "Speicherung",
    privacyRetentionText:
      "Die Daten werden so lange aufbewahrt, wie es für die Bearbeitung der Bestellungen, die Erfüllung gesetzlicher Pflichten und die Verwaltung der Geschäftsbeziehung erforderlich ist.",
    privacySectionRights: "Ihre Rechte",
    privacyRightsText:
      "Sie können im Rahmen des geltenden Rechts Auskunft, Berichtigung oder Löschung Ihrer Daten verlangen, indem Sie das Unternehmen über die im Impressum angegebenen Kontaktdaten kontaktieren.",

    twintTermsTitle: "TWINT-Zahlungsbedingungen",
    twintTermsUpdated: "Letzte Aktualisierung: 31. Oktober 2024",
    twintTermsIntro:
      "TWINT ist eine der führenden Instant-Payment-Apps in der Schweiz. TWINT ermöglicht es Nutzern, ihr Bankkonto oder ihre Karten mit der TWINT-App zu verbinden, um sichere Zahlungen vorzunehmen. Ihre Akzeptanz und Nutzung von TWINT über die Stripe-Zahlungsdienste unterliegt diesen Bedingungen für Zahlungsmethoden, die die Stripe Services Agreement in Bezug auf Ihre Akzeptanz und Nutzung von TWINT ergänzen:",
    twintTermsItems: [
      "Wenn Sie die Zahlungsmethode TWINT für Dienstleistungen akzeptieren, die nicht sofort erbracht werden können, verpflichten Sie sich, Ihre Kunden schriftlich über die spätere Erbringung der Dienstleistung zu informieren.",
      "Sie verpflichten sich, die Mobiltelefonnummer des Kunden, der TWINT verwendet, einzuholen und diese Angaben zu überprüfen.",
      "Sie verpflichten sich, die Mobiltelefonnummer des Kunden auf Anfrage an Stripe weiterzugeben.",
      "Bei der Verarbeitung von Fernabsatztransaktionen mit physischer Warenlieferung verpflichten Sie sich, den Nachnamen, Vornamen, die Mobiltelefonnummer und die Wohnadresse des Kunden, der TWINT verwendet, einzuholen und diese Angaben zu überprüfen, insbesondere wenn Wohnadresse und Lieferadresse unterschiedlich sind. Sie sind verpflichtet, den in Ihrem Online-Shop oder Ihrer App verwendeten Firmennamen in allen dem TWINT-Kunden bereitgestellten Informationen anzugeben (z. B. Bestell- oder Lieferbestätigungen, Rechnungen).",
    ],
    fondueBack: "Zurück",
    fondueBrand: "STERCHI",
    fondueHeroTitle: "STELLEN SIE IHRE FONDUE ZUSAMMEN",
    fondueHeroText:
      "Entdecken Sie unsere traditionellen Schweizer Rezepte oder kreieren Sie Ihre eigene Mischung nach Ihrem Geschmack.",

    fondueTraditionalTitle: "TRADITIONELLE FONDUES",
    fondueTraditionalSubtitle: "Entdecken Sie unsere kantonalen Rezepte",

    fondueCustomSubtitle:
      "Wählen Sie Ihre Käse und stellen Sie Ihre Mischung zusammen",

    fondueQualityTitle: "Premium-Qualität",
    fondueQualityText: "AOP-Käse",
    fondueCraftTitle: "Mit Leidenschaft gemacht",
    fondueCraftText: "Maison Sterchi",
    fonduePickupTitle: "Vor Ort",
    fonduePickupText: "Bereit bei Ihrer Ankunft",
    fondueCustomTitle: "Meine Mischung",
    fondueCustomIntroTitle: "Stellen Sie Ihr Caquelon zusammen",
    fondueCustomIntroText:
      "Wählen Sie bis zu 3 Käsesorten und bestimmen Sie anschliessend das Verhältnis Ihrer Mischung. Die Summe muss 100% ergeben.",

    fonduePeopleCount: "Anzahl Personen",
    fondueRecommendedQuantity: "Empfohlene Menge",
    fondueCategories: "Kategorien",
    fondueSearchPlaceholder: "Käse suchen...",
    fondueChooseCategoryHint:
      "Wählen Sie eine Kategorie, um die verfügbaren Käsesorten zu sehen.",

    fondueCategoryGoatSheep: "Ziege & Schaf",
    fondueCategoryBlue: "Blauschimmel",
    fondueCategoryHard: "Hart & halbhart",
    fondueCategorySoft: "Weichkäse",

    fondueAvailableCheeses: "Verfügbare Käsesorten",
    fondueNoCheeseInCategory: "In dieser Kategorie ist kein Käse verfügbar.",
    fondueAddToCaquelon: "Zum Caquelon hinzufügen",
    fondueInCaquelon: "Im Caquelon",

    fondueMyMix: "Meine Mischung",
    fondueMixEmpty:
      "Fügen Sie einen Käse zum Caquelon hinzu, um Ihre Mischung zu beginnen.",
    fondueValidateCaquelon: "Caquelon bestätigen",

    fondueRatioTitle: "Stellen Sie Ihr ideales Fondue zusammen",
    fondueRatioSubtitle: "Wählen Sie Ihre Verhältnisse",
    fondueSelectedCheeseSingular: "Käse ausgewählt",
    fondueSelectedCheesePlural: "Käsesorten ausgewählt",
    fondueRatioTip:
      "Tipp: Je höher der Anteil eines Käses ist, desto präsenter ist sein Geschmack im Fondue.",
    fondueRatioTotal: "Verhältnis total",

    fondueAddToCart: "In den Warenkorb",
    fondueValidateCaquelonFirst: "Bestätigen Sie zuerst das Caquelon",
    fondueCustomAddedToCart: "Individuelles Fondue",
    fondueRatioRequired: "100% Verhältnis erforderlich",
    fondueRatioMustBe100: "Die Summe der Verhältnisse muss 100% ergeben",
    fondueAddOneCheese: "Fügen Sie mindestens einen Käse zum Caquelon hinzu",
    fondueMaxThreeCheeses: "Maximal 3 Käsesorten pro Caquelon",
    heroTrustSubtitle: "Seltene Auswahlen, mit Leidenschaft gewählt.",
    heroTrustCheese: "AUSSERGEWÖHNLICHE KÄSE",
    heroTrustCave: "WEINKELLER-AUSWAHL",
    heroTrustPlateaux: "PERSONALISIERTE PLATTEN",
    heroTrustOffers: "PRIVATE ANGEBOTE",
  },

  en: {
    title: "Reserved selections",
    subtitle: "Access the selections reserved for our app.",
    discover: "SELECTION",
    services: "Our Services",
    actions: "OFFERS",
    shop: "SHOP",
    products: "PRODUCTS",
    onlineShop: "ONLINE SHOP",
    eventPlatters: "OUR EVENT PLATTERS",
    login: "LOGIN",
    myAccount: "MY ACCOUNT",
    myCart: "MY CART",
    cartNav: "CART",
    search: "Search...",
    historyOpen: "Discover the story",
    historyClose: "Close story",
    addCart: "ADD TO CART",
    soldOut: "SOLD OUT",
    allProducts: "All categories",
    composeFondue: "CREATE YOUR FONDUE",
    eventPlattersShort: "CONFIGURE YOUR EVENT PLATTER",

    menu: "Menu",
    close: "Close",
    home: "HOME",
    mainNavigation: "Main navigation",

    browse: "BROWSE",
    categoriesTitle: "Our selection",
    categoriesSubtitle: "Choose a product family and explore our selection.",
    milkTypeFilterKicker: "Refine",
    milkTypeFilterTitle: "Milk type",
    allMilkTypes: "All milk types",
    milkTypeRaw: "Raw milk",
    milkTypePasteurized: "Pasteurized",
    milkTypeThermized: "Thermized",

    // Wine cellar / alcohol
    alcoolHeroTitle: "WE OFFER EXACTLY WHAT YOU ARE LOOKING FOR",
    alcoolDiscoverShop: "Discover the shop",
    alcoolSelectionKicker: "Selection on display",
    homeAlcoholEntryAria: "Wine cellar entry",
    homeAlcoholEntryKicker: "DeLuxe cellar universe",
    homeAlcoholEntryButton: "Enter the cellar",

    exclusiveOffers: "ENJOY OUR EXCLUSIVE OFFERS",
    viewAll: "VIEW ALL OFFERS",
    memberPriceShort: "MEMBERS",
    alcoolAgeGateTitle: "Are you 18 or older?",
    alcoolAgeGateText:
      "Access to this section is restricted to adults. Please confirm that you are at least 18 years old.",
    alcoolAgeGateAccept: "I am 18 or older",
    alcoolAgeGateDecline: "I am under 18",
    alcoolAgeGateKicker: "Restricted access",

    welcome: "Welcome",
    phone: "Phone",
    address: "Address",
    saveChanges: "Save changes",
    logout: "LOGOUT",
    updating: "Updating...",
    password: "Password",
    signIn: "Sign in",
    loginAction: "SIGN IN",
    createAccount: "CREATE AN ACCOUNT",
    accessExclusive: "Access your Marché Deluxe universe",
    myOrders: "MY ORDERS",
    myDetails: "YOUR DETAILS",
    editMyInfo: "EDIT MY INFO",
    orderHistory: "ORDER HISTORY",
    paymentNotConfirmedTitle: "Payment not confirmed",
    payThisOrder: "PAY MY ORDER",
    orderNumber: "Order number",
    pricePaid: "Paid price",
    orderTotal: "Order total",
    status: "Status",
    deliveryMode: "Collection method",
    orderDate: "Order date",
    specialInstructions: "Special instructions",
    emptyCartData: "Cart unavailable.",
    noOrdersYet: "No orders yet.",
    processing: "Processing...",
    email: "Email",

    // Logout modal
    logoutModalTitle: "Your selection is waiting",
    logoutModalText:
      "Your cart is preserved in your personal cellar.\nBy logging out, you will lose your member benefits and your selection will be reset.",
    logoutModalStay: "Keep my cart",
    logoutModalLeave: "Continue as guest (reset cart)",
    logoutModalMoreItems: "+ {count} more delights...",

    // Suppression de commande
    deleteOrder: "DELETE ORDER",
    deletingOrder: "DELETING...",
    deleteOrderConfirm: "Are you sure you want to delete order #{id}?",
    deleteOrderNotAllowed:
      "This order cannot be deleted yet. An unpaid order can only be deleted 3 days after creation.",
    deleteOrderInfo:
      "This unpaid order can be deleted 3 days after its creation.",

    cartTitle: "YOUR CART",
    emptyCart: "Your selection is empty",
    backToShop: "Back to the shop",
    discoverCaveUniverse: "Discover the wine cellar universe",
    summary: "SUMMARY",
    subtotal: "Subtotal",
    total: "TOTAL",
    checkout: "CHECKOUT",
    finalizeOrder: "FINALIZE MY ORDER",
    pickupMode: "Pickup method",
    deliveryLocal: "LOCAL DELIVERY",
    shipping: "Shipping",
    pickPay: "Pick & Pay",
    yourInfo: "Your information",
    firstName: "First name",
    lastName: "Last name",
    npa: "ZIP",
    city: "City",
    payment: "Payment",
    creditCard: "Credit card",
    invoice: "Invoice",
    totalToPay: "TOTAL TO PAY",
    items: "Items",
    fees: "Fees",
    pay: "PAY",
    validating: "VALIDATION IN PROGRESS...",
    backToCart: "Back to cart",
    thankYouOrder: "Thank you for your order",
    orderRegistered: "Your order has been successfully registered.",
    redirectingPayment: "REDIRECTING TO PAYMENT...",
    cartRecommendationsInlineTitle: "Perfect with",
    addToCart: "Add",

    securePaymentTitle: "Secure payment",
    availablePaymentMethods: "Available payment methods",
    securePaymentFinalChoice:
      "The final payment method is selected on the secure payment page.",
    bankCardLabel: "Credit card",
    twintLabel: "TWINT",

    freeDeliveryTarget: "{{amount}} CHF left for free delivery!",
    deliveryFees: "Delivery",
    deliveryInstructions: "Delivery instructions:",
    deliveryPlaceholder: "details...",
    prepNotes: "Preparation notes (e.g. vacuum packed):",
    prepPlaceholder: "Special instructions (packaging, etc.)...",
    pickupTime: "PICKUP TIME:",
    chooseSlot: "Choose a time slot",
    free: "FREE",

    servicesSubtitle:
      "A simple, fast and premium experience — from cart to tasting.",
    ctaShop: "Go to shop",
    ctaCart: "View my cart",
    howItWorks: "How it works",
    step1Title: "1. Choose your products",
    step1Text: "Browse the selection and add items to your cart.",
    step2Title: "2. Delivery or pickup",
    step2Text: "Select the collection method that suits you best.",
    step3Title: "3. Finish easily",
    step3Text: "Confirm your order in just a few seconds.",
    serviceReadyTitle: "Your selection is ready to go",
    serviceReadyText: "Order, collect and enjoy.",
    pick1: "Careful and fast preparation",
    pick2: "Simple and efficient pickup",
    pick3: "Premium quality, no waiting",
    ctaOrder: "Order now",
    ctaFinalize: "Finalize my order",

    deliveryTitle: "Local Delivery",
    deliveryZone: "Delivery in Neuchâtel and nearby areas.",
    deliveryFree: "Free from CHF 59.00",
    deliveryBeforeLabel: "Before 12:00",
    deliveryBefore: "Same-day delivery",
    deliveryAfterLabel: "After 12:00",
    deliveryAfter: "Next-day delivery",

    faq: "FAQ",
    faqQ1: "Can I order without an account?",
    faqA1:
      "Yes, you can order as a guest (first name, last name and phone required).",
    faqQ2: "Can I choose a time slot?",
    faqA2: "Yes, in Pick & Pay mode you can choose your pickup time slot.",
    panierAlcoholNotice:
      "By placing this order, you confirm that you are at least 18 years old to purchase alcoholic beverages.",
    panierWeightNotice:
      "Products cut to weight are prepared with care in store. The final weight may be slightly above the quantity ordered. The price charged remains that of the quantity ordered.",

    // Event platters
    plateauxPageTitle: "OUR EVENT PLATTERS",
    plateauxPageKicker: "Event platters",
    plateauxPageIntro:
      "Discover our artisanal platters designed for your events, aperitifs and convivial meals. Start by choosing the platter type that best fits your occasion. You will then be able to personalise it (number of guests, preferences and restrictions) before adding it to your cart.",
    plateauxHeroAlt: "Event platters illustration",
    plateauxSelectionTitle: "Choose a platter type",
    plateauxSelectionKicker: "Step 1",
    plateauxConfigTitle: "Configure your platter",
    plateauxConfigKicker: "Step 2",
    plateauxSelectionHint:
      "Start by choosing a base. The customisation options will then appear just below.",
    plateauxChangeSelection: "See other platters",
    plateauxSelectedLabel: "Selected platter",
    plateauxEmptyState:
      "Select a platter to display the detailed configuration.",
    plateauxNoItemsAvailable: "No platters are available at the moment.",

    plateauConfiguratorKicker: "Platter configuration",
    plateauEditorialHighlight:
      "Artisanal platter prepared by our cheesemongers. Ideal for your events, aperitifs and convivial meals.",
    plateauConsignesTitle: "Platter surcharges",
    plateauConsigneSmall: "Small",
    plateauConsigneMedium: "Medium",
    plateauConsigneLarge: "Large",
    plateauPeopleLabel: "Number of people",
    plateauPeopleHelper:
      "The price is calculated automatically according to the number of guests.",
    plateauDecreasePeople: "Decrease number of people",
    plateauIncreasePeople: "Increase number of people",
    plateauCheesePreferencesLabel: "Cheese preferences",
    plateauOptional: "(optional)",
    plateauCheesePreferencesPlaceholder: "E.g.: Comté, Gruyère, Tomme, Blue...",
    plateauAvoidMilkTypesLabel: "Avoid certain milk types",
    plateauRawMilk: "Raw milk",
    plateauThermizedMilk: "Thermised milk",
    plateauPasteurizedMilk: "Pasteurised milk",
    plateauMilkNote:
      "The platters contain several cheeses. You can indicate here which milk types you would like to avoid.",
    plateauPricePerPerson: "Price per person",
    plateauPeopleCount: "Number of people",
    plateauPreferences: "Preferences",
    plateauAvoid: "Avoid",
    plateauNoPreference: "No preference",
    plateauNoRestriction: "No restriction",
    plateauTotal: "Total",
    plateauAddToCart: "Add to cart",
    plateauDelayInfo: "Platters must be ordered at least 24 hours in advance.",
    plateauPriceSuffix: "/ person",
    plateauSelected: "✓ Selected",
    plateauChoose: "Choose",
    plateauAddedToCart: "Platter added to cart",
    plateauPostAddShop: "Discover the shop",
    plateauPostAddCave: "Visit our cellar",
    plateauPostAddTop: "Back to top",

    categories: {
      fromage_vache: "Cow cheese",
      fromage_brebis: "Sheep cheese",
      fromage_chevre: "Goat cheese",
      charcuterie: "Deli meats",
      produit_laitier: "Dairy products",
      panier_garni: "Gift baskets",
      vin: "Wines",
      divers: "Miscellaneous",
      oeuf: "Eggs",
    },

    forgotPassword: "Forgot password?",
    forgotPasswordTitle: "Forgot password",
    forgotPasswordSubtitle: "Receive a password reset link by email.",
    sendResetLink: "SEND RESET LINK",
    resetPasswordTitle: "New password",
    resetPasswordSubtitle: "Choose a new password for your account.",
    resetPasswordAction: "RESET PASSWORD",
    confirmPassword: "Confirm password",
    backToLogin: "Back to login",
    resetMailSent:
      "If an account exists with this email, a reset link has been sent.",
    resetSuccess: "Your password has been successfully reset.",
    resetError: "Unable to reset the password.",

    legalNotices: "Legal notice",
    privacyPolicy: "Privacy policy",
    twintTermsNav: "TWINT terms",

    legalPageTitle: "Legal notice",
    legalPageSubtitle:
      "Legal information relating to the website publisher and the operation of the online shop.",
    legalSectionCompany: "Company identification",
    legalSectionContact: "Contact details",
    legalSectionHosting: "Hosting and infrastructure",
    legalSectionUsage: "Terms of use",
    legalCompanyNameLabel: "Company name",
    legalCompanyNameValue: "La Maison du Fromage Neuchâtel - Sterchi Sàrl",
    legalAddressLabel: "Address",
    legalAddressValue: "rue du Trésor 2 bis, 2000 Neuchâtel, Switzerland",
    legalLegalFormLabel: "Legal form",
    legalLegalFormValue: "Limited liability company (Sàrl)",
    legalVatLabel: "VAT number",
    legalVatValue: "CHE-192.944.984 TVA",
    legalPhoneLabel: "Phone",
    legalPhoneValue: "+41 32 725 26 36",
    legalEmailLabel: "Email",
    legalEmailValue: "neuch@sterchi-fromages.ch",
    legalHostingText:
      "The Marché Deluxe website and application are operated on a secure web infrastructure. The e-commerce application is accessible via app.marchedeluxe.ch.",
    legalUsageTitle: "Terms of use",
    legalUsageItems: [
      "Use of the Marché Deluxe website implies acceptance of a use consistent with its purpose, namely consulting products, preparing purchases, placing orders and accessing the customer area.",
      "The user agrees to provide accurate information when creating an account, placing an order and during any communication with the shop.",
      "Any fraudulent, abusive or disruptive use affecting the proper functioning of the website may result in restricted access or any appropriate measure decided by the operator.",
      "The content available on the website (texts, visuals, graphic elements, photographs and information) is protected and may not be reproduced, copied or used without prior authorisation.",
      "The availability of the website cannot be guaranteed at all times. The operator reserves the right to suspend or modify all or part of the service for maintenance, updates or technical reasons.",
    ],

    privacyPageTitle: "Privacy policy",
    privacyPageSubtitle:
      "Information on the collection, use and protection of personal data within Marché Deluxe.",
    privacyIntro:
      "This privacy policy explains what data may be collected when you use the Marché Deluxe website and application, and how that data is used for order processing, customer relationship management and service security.",
    privacySectionCollected: "Data collected",
    privacyCollectedItems: [
      "Account information: first name, last name, email, phone, address, ZIP code, city.",
      "Order information: cart contents, pickup or delivery mode, order notes, payment status.",
      "Technical information required for service operation and application security.",
    ],
    privacySectionUsage: "Use of data",
    privacyUsageItems: [
      "Prepare, process and deliver orders.",
      "Manage customer relations and respond to requests.",
      "Track payments and prevent fraud.",
      "Maintain the security, stability and continuity of the service.",
    ],
    privacySectionSharing: "Data sharing",
    privacySharingText:
      "Some data may be shared with service providers strictly necessary for operating the service, particularly for payment, hosting and order fulfilment. These transfers are limited to what is necessary.",
    privacySectionRetention: "Retention",
    privacyRetentionText:
      "Data is retained for as long as necessary to process orders, comply with legal obligations and manage the business relationship.",
    privacySectionRights: "Your rights",
    privacyRightsText:
      "You may request access to, correction or deletion of your data, within the limits of applicable law, by contacting the company using the contact details provided in the legal notice.",

    twintTermsTitle: "TWINT Payment Terms",
    twintTermsUpdated: "Last Updated: October 31, 2024",
    twintTermsIntro:
      "TWINT is a leading instant payment mobile app used in Switzerland. TWINT allows users to connect their bank account or cards with the TWINT app to make secure payments. Your acceptance and use of TWINT via the Stripe Payments Services is subject to these Payment Method Terms, which supplement the Stripe Services Agreement with respect to your acceptance and use of TWINT:",
    twintTermsItems: [
      "Where you accept the TWINT payment method for services that cannot be provided immediately, you agree to inform your Customers about the later provision of the service in writing.",
      "You agree to obtain the mobile phone number of the Customer using TWINT and verify these details.",
      "You agree to share the mobile phone number of the Customer with Stripe when requested to do so.",
      "When processing distance transactions involving a purchase transaction with the physical delivery of goods, you agree to obtain the last name, first name, mobile phone number and residential address of the Customer using TWINT and verify these details; especially in cases in which the residential address and delivery address differ. You are required to state the company name used in your online shop or app in all information provided to the Customer using TWINT (e.g. order or delivery confirmations, invoices).",
    ],
    fondueBack: "Back",
    fondueBrand: "STERCHI",
    fondueHeroTitle: "CREATE YOUR FONDUE",
    fondueHeroText:
      "Discover our traditional Swiss recipes or create your own blend to match your taste.",

    fondueTraditionalTitle: "TRADITIONAL FONDUES",
    fondueTraditionalSubtitle: "Discover our cantonal recipes",

    fondueCustomSubtitle: "Choose your cheeses and create your blend",

    fondueQualityTitle: "Premium quality",
    fondueQualityText: "AOP cheeses",
    fondueCraftTitle: "Made with passion",
    fondueCraftText: "Maison Sterchi",
    fonduePickupTitle: "On site",
    fonduePickupText: "Ready when you arrive",
    fondueCustomTitle: "My composition",
    fondueCustomIntroTitle: "Compose your caquelon",
    fondueCustomIntroText:
      "Select up to 3 cheeses, then choose the ratio of your blend. The total must be 100%.",

    fonduePeopleCount: "Number of people",
    fondueRecommendedQuantity: "Recommended quantity",
    fondueCategories: "Categories",
    fondueSearchPlaceholder: "Search for a cheese...",
    fondueChooseCategoryHint: "Select a category to see the available cheeses.",

    fondueCategoryGoatSheep: "Goat & Sheep",
    fondueCategoryBlue: "Blue cheeses",
    fondueCategoryHard: "Hard & semi-hard",
    fondueCategorySoft: "Soft cheeses",

    fondueAvailableCheeses: "Available cheeses",
    fondueNoCheeseInCategory: "No cheese available in this category.",
    fondueAddToCaquelon: "Add to caquelon",
    fondueInCaquelon: "In caquelon",

    fondueMyMix: "My blend",
    fondueMixEmpty: "Add a cheese to the caquelon to start your blend.",
    fondueValidateCaquelon: "Validate my caquelon",

    fondueRatioTitle: "Create your ideal fondue",
    fondueRatioSubtitle: "Select your ratios",
    fondueSelectedCheeseSingular: "selected cheese",
    fondueSelectedCheesePlural: "selected cheeses",
    fondueRatioTip:
      "Tip: the higher the share of a cheese, the more present its taste will be in your fondue.",
    fondueRatioTotal: "Total ratios",

    fondueAddToCart: "Add to cart",
    fondueValidateCaquelonFirst: "Validate the caquelon first",
    fondueCustomAddedToCart: "Custom fondue",
    fondueRatioRequired: "100% ratio required",
    fondueRatioMustBe100: "The ratio total must be 100%",
    fondueAddOneCheese: "Add at least one cheese to the caquelon",
    fondueMaxThreeCheeses: "Maximum 3 cheeses per caquelon",
    heroTrustSubtitle: "Rare selections, chosen with passion.",
    heroTrustCheese: "EXCEPTIONAL CHEESES",
    heroTrustCave: "CELLAR SELECTIONS",
    heroTrustPlateaux: "PERSONALISED PLATTERS",
    heroTrustOffers: "PRIVATE OFFERS",
  },
};
